import {
  SET_HEADER,
  SET_IS_LOADING_APP,
  SET_LANGUAGE,
  SET_SNACKBAR,
  SET_SNACKBAR_SHOWING,
} from './mutation-types'
import { DataMutation, HeaderState, RootState, SnackbarState } from './types'

const mutationSetIsLoadingApp: DataMutation<RootState, boolean> = (state, loading) => {
  state.isLoadingApp = loading
}

const mutationSetSnackbarShowing: DataMutation<RootState, boolean> = (state, value) => {
  state.snackbar.showing = value
}

const mutationSetSnackbar: DataMutation<RootState, SnackbarState> = (
  state,
  { message, type, timeout, clearable },
) => {
  state.snackbar.type = type
  state.snackbar.message = message
  state.snackbar.timeout = timeout
  state.snackbar.clearable = clearable
}

const mutationSetLanguage: DataMutation<RootState, string> = (state, value) => {
  state.language = value
}

const mutationSetHeader: DataMutation<RootState, HeaderState> = (state, value) => {
  state.header = value
}

export default {
  [SET_IS_LOADING_APP]: mutationSetIsLoadingApp,
  [SET_SNACKBAR_SHOWING]: mutationSetSnackbarShowing,
  [SET_SNACKBAR]: mutationSetSnackbar,
  [SET_LANGUAGE]: mutationSetLanguage,
  [SET_HEADER]: mutationSetHeader,
}
